import { IconButton } from "@circleco/compass/components/IconButton";
import { Tooltip } from "@circleco/compass/components/Tooltip";
import { useState } from "react";

import { t } from "@/i18n-js/instance";
import { useBrowserSupportsVoiceRecording } from "@/react/hooks/useBrowserSupportsVoiceRecording";

import { WaveSurferRecorder } from "./components/WaveSurferRecorder";

export const VoiceMessage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const onClose = () => setIsOpen(false);
  const onOpen = () => setIsOpen(true);

  const doesBrowserSupportVoiceRecording = useBrowserSupportsVoiceRecording();

  if (!doesBrowserSupportVoiceRecording) {
    return null;
  }

  return (
    <>
      <Tooltip content={t("tiptap.voice_message.action")} side="bottom">
        <IconButton
          icon="microphone"
          size="md"
          variant="ghost"
          onClick={onOpen}
          aria-label={t("tiptap.voice_message.action")}
        />
      </Tooltip>
      {isOpen && <WaveSurferRecorder onClose={onClose} />}
    </>
  );
};
